import React from 'react';

// Hooks
import { useUpdateAiSetting } from 'Shared/utils/hooks/use-update-ai-setting';

// Components
import TemplateSectionItem from './TemplateSectionItem';
import DefaultTemplateSectionList from './DefaultTemplateSectionList';

type Props = {
  updateAiSettingSlug: string;
  handleRegerateSection: Function;
};

const TemplateSections = ({ updateAiSettingSlug, handleRegerateSection }: Props) => {
  const { sections } = useUpdateAiSetting({ slug: updateAiSettingSlug });

  const baseClassName = 'TemplateSections';

  return (
    <div className={baseClassName}>
      {sections.map((section, index) => (
        <TemplateSectionItem
          key={`template-section-${section.slug}`}
          section={section}
          number={index + 1}
          handleRegerateSection={handleRegerateSection}
        />
      ))}
      <DefaultTemplateSectionList updateAiSettingSlug={updateAiSettingSlug} />
    </div>
  );
};

export default TemplateSections;
